export default __webpack_public_path__ + "static/media/high-risk.f5ab4380.jpg";